export default __webpack_public_path__ + "static/creditLife-4330aa19c3a413e0a5777458e3cc320f.svg";